// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"c3a71a48","2186":"2f84023e","4509":"1a4e3395","5787":"b692bdae"}[chunkId] + ".chunk.css";
};